<ui-modal-header mat-dialog-title>{{title}}</ui-modal-header>
<mat-dialog-content [innerHTML]="body" class="dialog__content"></mat-dialog-content>
